module.exports = __webpack_public_path__ + "img/icon_warn@2x.fa8b8b84.png";